import * as React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import {UIState} from "../../../data/UIState";



interface Props {
  rawHTML:string;
  user:any;
  settings:any;
}

@observer
export class ModalContent extends React.Component<Props> {

  @computed
  get processedContent() {

    let content = this.props.rawHTML;
    if(!content) {
      content = "Unfortunately, the content referenced appears to be unavailable.";
    } else {

      const solution = UIState.feedData && UIState.feedData.feedLoaded ? UIState.feedData.solution : null;

      content = content.replace(/{{firstName}}/g, this.props.user.firstName);
      content = content.replace(/{{firstName}}/g, this.props.user.lastName);
      content = content.replace(/{{email}}/g, this.props.user.email);
      content = content.replace(/{{companyName}}/g, this.props.settings.COMPANY_NAME);
      content = content.replace(/{{launchDate}}/g, solution ? solution.openDate : this.props.settings.PLATFORM_OPEN_DATE);
      content = content.replace(/{{portalName}}/g, solution ? solution.name : this.props.settings.PLATFORM_NAME);
      content = content.replace(/{{installSubdomain}}/g, this.props.settings.INSTALL_SUBDOMAIN);
    }
    return {
      __html: content
    }
  }

  render(){
    return <div dangerouslySetInnerHTML={this.processedContent}></div>
  }

}
